import { FaFileContract } from "react-icons/fa";
import DropdownItemBase from "./DropdownItemBase";
import { useTranslation } from "react-i18next";

const DropdownItemAlvara = ({ notif, onClick }) => {
    const { t } = useTranslation(['layout']);
    const info = notif.prestador_info;
    if (!info) return null;

    const dias = info.dias_para_vencimento;
    const corIcone = dias <= 5 ? "text-danger" : dias <= 15 ? "text-warning" : "text-primary";

    const descricao = (
        <>
            <strong>{info.nome}</strong>
            {info.programa_nome && <span className="text-muted"> · {info.programa_nome}</span>}
            {info.data_vencimento_alvara && (
                <span> — {t('layout:notificationItems.license.expiresOn', { data: info.data_vencimento_alvara })}</span>
            )}
        </>
    );

    return (
        <DropdownItemBase
            icon={<FaFileContract />}
            text={corIcone}
            titulo={t('layout:notificationItems.license.title', { count: dias })}
            descricao={descricao}
            dataFormatada=""
            onClick={() => onClick(notif)}
        />
    );
};

export default DropdownItemAlvara;
